import Image from 'next/future/image';
import { useRouter } from 'next/router';
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import { useContext, useEffect, useState } from 'react';

import BreadCrumbs from '@/components/breadcrumbs/breadcrumb';
import CanonicalURL from '@/components/common/Canonical';
import { generateDynamicBCLD, getSEOProps } from '@/components/utility';
import HeaderFooterContext from '@/context/HeaderFooterContext';
import { replaceWithRequiredSiteInfo } from '@/helper/wordReplace';
import { getBlogBySlug } from '@/services/blogs';
import SetBrandsContext from '@/services/home/setBrands';
import {
  BRAND_NAME_EN,
  BRAND_NAME_FR,
  SITE_TITLE,
  SITE_URL,
} from '@/utils/constants';

import PageNotFound from '../404';

const SpecificBlogItem = ({ hostUrl, blogResData }: any) => {
  const { locale } = useRouter();
  const router = useRouter();
  const brandUrl = hostUrl ? `https://${hostUrl}` : SITE_URL;
  let newArray: any;
  const [title, setTitle] = useState();
  const [contents, setContents] = useState();
  const [img, setImg] = useState();
  const [imgAlt, setImgAlt] = useState('');
  const headerFooterData = useContext(HeaderFooterContext);
  const { headerFooter } = headerFooterData;
  const [err, setErr] = useState(false);
  const [blogSlugData, setBlogSlugData] = useState<any>([]);
  let blogSlugDataL;
  const isContext = !!headerFooter[0];
  const pathWithoutQuery = router.asPath.split('?')[0];

  const getBlog = async () => {
    if (
      blogResData?.data?.length === 0 &&
      !sessionStorage.getItem('blogCords')
    ) {
      setErr(true);
    } else {
      setErr(false);
    }
    blogSlugDataL = blogResData?.data[0]?.attributes;
    setBlogSlugData(blogSlugDataL);
    setImg(blogSlugDataL?.Thumbnail?.data?.attributes?.url);
    setImgAlt(
      blogSlugDataL?.Thumbnail?.data?.attributes?.alternativeText ||
        blogSlugDataL?.Thumbnail?.data?.attributes?.name
    );

    setContents(blogSlugDataL?.Content);
    setTitle(blogSlugDataL?.Title);

    const lang = blogSlugDataL?.locale;
    const loc = blogSlugDataL?.localizations?.data[0]?.attributes?.locale;
    newArray = [
      { lan: lang, slugValue: blogSlugDataL?.Slug },
      {
        lan: loc,
        slugValue: blogSlugDataL?.localizations?.data[0]?.attributes?.Slug,
      },
    ];
    if (newArray[0].lan) {
      sessionStorage.setItem('blogCords', JSON.stringify(newArray));
    }
  };
  useEffect(() => {
    getBlog();
  }, [locale, blogResData]);

  const getContextData = async () => {
    let defaultBrand = BRAND_NAME_EN;
    if (locale === 'fr') defaultBrand = BRAND_NAME_FR;
    const contextData = await SetBrandsContext(defaultBrand, locale);
    const brands = contextData?.data;
    headerFooterData.setHeaderFooterData(brands);
  };
  useEffect(() => {
    getContextData();
  }, [isContext, locale]);

  const brandTitle =
    SITE_TITLE || blogSlugData?.Brands?.data[0]?.attributes?.Site_Title;

  const seoProps = getSEOProps(blogResData?.data[0]?.attributes?.SEO, router);
  const breadCrumbUrlList = generateDynamicBCLD(router);
  return (
    <>
      <CanonicalURL />
      <NextSeo {...seoProps} />
      <BreadcrumbJsonLd itemListElements={breadCrumbUrlList} />

      {!err ? (
        <>
          <div className="sv-page-content blog-detail-wrapper">
            <div className="container">
              <section className="blog-banner">
                <div className="row">
                  <div className="col-lg-12 col-md-12 col-sm-12">
                    <Image
                      sizes="(max-width: 375px) 295px, (max-width: 576px) 540px, (max-width: 768px) 720px, (max-width: 992px) 960px, (max-width: 1280px) 1140px"
                      src={img || ''}
                      alt={imgAlt || 'as-our-team'}
                      width="1110"
                      height="425"
                    />
                  </div>
                </div>
              </section>
            </div>
            <BreadCrumbs path={pathWithoutQuery} />
            <div className="container">
              <section className="blog-content">
                <h1 className="main-heading">{title}</h1>
                <div
                  className="para"
                  dangerouslySetInnerHTML={{
                    __html: replaceWithRequiredSiteInfo(
                      brandTitle,
                      brandUrl,
                      contents
                    ),
                  }}
                />
              </section>
            </div>
          </div>
        </>
      ) : (
        <PageNotFound />
      )}
    </>
  );
};

export async function getServerSideProps(props: any) {
  let brand = BRAND_NAME_EN;
  const locale = props?.locale;
  if (locale === 'fr') {
    brand = BRAND_NAME_FR;
  }

  const blogRes: any = await Promise.all([
    getBlogBySlug(brand, props?.params?.slug, locale),
  ]);
  const host = props?.req?.headers?.host;

  const hostUrl = `${host}/${locale}`;
  return { props: { hostUrl, blogResData: blogRes[0].data } };
}

export default SpecificBlogItem;
